import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { SxProps, Theme } from '@mui/material/styles';
import { shouldHideForbiddenActions } from '../../utils/permission-ui';

interface PermissionButtonProps extends ButtonProps {
  [key: string]: any;
  allowed: boolean;
  deniedTooltip: string;
  tooltip?: React.ReactNode;
  spanSx?: SxProps<Theme>;
  hideWhenForbidden?: boolean;
}

const PermissionButton: React.FC<PermissionButtonProps> = ({
  allowed,
  deniedTooltip,
  tooltip = '',
  disabled = false,
  onClick,
  spanSx,
  hideWhenForbidden,
  ...buttonProps
}) => {
  const shouldHideWhenForbidden =
    hideWhenForbidden ?? shouldHideForbiddenActions();

  if (!allowed && shouldHideWhenForbidden) {
    return null;
  }

  const isDisabled = disabled || !allowed;
  const title = !allowed ? deniedTooltip : tooltip;
  const spanStyles = Array.isArray(spanSx)
    ? [{ display: 'inline-flex' }, ...spanSx]
    : [{ display: 'inline-flex' }, spanSx];

  return (
    <Tooltip
      title={title}
      disableHoverListener={!title}
      disableFocusListener={!title}
      disableTouchListener={!title}
    >
      <Box component="span" sx={spanStyles}>
        <Button
          {...buttonProps}
          disabled={isDisabled}
          onClick={isDisabled ? undefined : onClick}
        />
      </Box>
    </Tooltip>
  );
};

export default PermissionButton;
